// extracted by mini-css-extract-plugin
export default {"tableHeader":"dataTable_tableHeader__i4yY6","noBg":"dataTable_noBg__MoaTT"};